import React, { useMemo } from "react";
import ReportViewer from "./components/ReportViewer";
import { generateStandardReportPdf } from "./utils/reportPdfGenerators";
import moment from "moment";

export default function ActivityReport() {
  const formatDateTime = (value) => {
    if (!value) return "-";
    const m = moment(value, [moment.ISO_8601, "YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD", "DD/MM/YYYY", "DD/MM/YYYY HH:mm:ss"], true);
    return m.isValid() ? m.format("DD/MM/YYYY hh:mm A") : String(value);
  };

  const columns = useMemo(
    () => [
      { name: "Date", selector: (r) => formatDateTime(r.CreatedAt) },
      { name: "User", selector: (r) => r.UserName || r.FullName || "-" },
      { name: "Module", selector: (r) => r.ModuleName || "-" },
      { name: "Action", selector: (r) => r.ActionName || "-" },
      { name: "Details", selector: (r) => r.Details || "-" },
    ],
    []
  );

  return (
    <ReportViewer
      reportKey="activity"
      title="Activity Report"
      columns={columns}
      fetchConfig={{
        url: "/reports/app2/activity",
        paramsBuilder: (filters) => ({
          fromDate: filters.fromDate,
          toDate: filters.toDate,
          moduleName: filters.moduleName || "",
          userId: filters.userId || "",
        }),
      }}
      renderFilters={(filters, setFilters) => (
        <>
          <div className="col-sm-12 col-md-3">
            <label className="form-label">Module</label>
            <input
              type="text"
              className="form-control"
              placeholder="e.g. Dashboard"
              value={filters.moduleName || ""}
              onChange={(e) => setFilters((p) => ({ ...p, moduleName: e.target.value }))}
            />
          </div>
          <div className="col-sm-12 col-md-2">
            <label className="form-label">UserId</label>
            <input
              type="number"
              className="form-control"
              value={filters.userId || ""}
              onChange={(e) => setFilters((p) => ({ ...p, userId: e.target.value }))}
            />
          </div>
        </>
      )}
      buildKpis={(rows) => [{ label: "Events", value: rows?.length ?? 0 }]}
      pdfGenerator={generateStandardReportPdf}
    />
  );
}

